import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export type HistoryCategory = 'all' | 'details' | 'financial';
export type HistoryValue = string | number | boolean | null;

export interface WorkOrderHistoryChange {
  field: string;
  label: string;
  before: HistoryValue;
  after: HistoryValue;
  kind: 'money' | 'value';
}

export interface WorkOrderHistoryEvent {
  id: string;
  changed_at: string;
  operation: 'INSERT' | 'UPDATE' | 'DELETE';
  entity: string;
  record_id: string;
  description: string | null;
  actor: {
    label: string;
    verified: boolean;
  };
  source: string;
  request_id: string | null;
  operation_id: string | null;
  changes: WorkOrderHistoryChange[];
  category: 'details' | 'financial';
}

export interface WorkOrderHistoryPage {
  ok: boolean;
  lading_uuid: string;
  events: WorkOrderHistoryEvent[];
  next_cursor: string | null;
  coverage: string;
  details_recording: boolean;
  can_view_financials: boolean;
  category: HistoryCategory;
}

@Injectable({ providedIn: 'root' })
export class WorkOrderHistoryService {
  constructor(private readonly http: HttpClient) {}

  load(
    ladingUuid: string,
    cursor: string | null,
    category: HistoryCategory = 'all'
  ): Observable<WorkOrderHistoryPage> {
    let params = new HttpParams()
      .set('lading_uuid', ladingUuid)
      .set('limit', '50')
      .set('category', category);

    // The cursor is opaque. Send back exactly what the API returned.
    if (cursor) {
      params = params.set('cursor', cursor);
    }

    // Jenny: the existing interceptor supplies the AMS login token. The PHP
    // helper supplies the API key and signed actor context when calling API2.
    return this.http.get<WorkOrderHistoryPage>('/api/work_orders/work_order_history.php', { params });
  }
}
